import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import { assignmentColumns, assignmentConfig } from '../../constants/MockData';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import GridTable from '../common/Table/Table';
import { Tooltip, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import {
  applyFilterOnData,
  cloneDeep,
  IsSectionVisible,
  removeDuplicates,
  UpdateColumnWithConfiguration
} from '../../utils/helper';
import AssignmentInfo from '../Assignments/AssignmentInfo';
import _ from 'lodash';
import { Operators, SECTIONS } from '../../constants/appConstants';

class Assignments extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      responseAssignmentData: [],
      assignmentData: [],
      serviceTypeMasterData: [],
      propertyMasterData: [],
      marketMasterData: [],
      configuration: [],
      selectedPropertyId: this.props.selectedPropertyId,
      detailView: false,
      ViewTitle: undefined,
      actionType: undefined,
      sortedAssignmentData: [],
      statusData: []
    };
  }

  GetAssignmentsDetails () {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Assignments.GetAssignmentsData + '?propertyId=' + (this.state?.selectedPropertyId?.toString() ?? '0'),
        key: 'assignmentData'
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: true,
        duration: 15
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 15
      }
    ])
      .then(
        ({
          assignmentData,
          serviceTypeMasterData,
          propertyMasterData,
          marketMasterData
        }) => {
          this._asyncRequest = null;
          if (assignmentData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          const selectedData = [];
          if (this.props.selectedPropertyId !== undefined) {
            selectedData.push({
              key: 'propertyName',
              selected: (propertyMasterData.data || []).filter(
                (x) => x.propertyId === parseInt(this.props.selectedPropertyId)
              )
            });
          }
          const sortedData = cloneDeep(assignmentData.data);
          function compare (a, b) {
            if (a.assignmentName.toLowerCase() < b.assignmentName.toLowerCase()) {
              return -1;
            }
            if (a.assignmentName.toLowerCase() > b.assignmentName.toLowerCase()) {
              return 1;
            }
            return 0;
          }
          sortedData.sort(compare);
          const statusData = sortedData.map(x => {
            const ab = {};
            if (ab.statusId !== x.statusId) {
              ab.statusId = x.statusId;
              ab.statusName = x.statusName;
            }
            return ab;
          });
          const newAssignmentData = (assignmentData.data).map(x => {
            if (x.assignemntDescription === null) {
              x.assignemntDescription = '';
            }
            return x;
          });
          // console.log(newAssignmentData);
          
          const uniqueStatusData = removeDuplicates(statusData, 'statusId');
          this.setState({
            configuration: assignmentData.config || [],
            responseAssignmentData: assignmentData.data || [],
            assignmentData: applyFilterOnData(
              newAssignmentData || [],
              selectedData
            ),
            serviceTypeMasterData: serviceTypeMasterData.data || [],
            propertyMasterData: propertyMasterData.data || [],
            marketMasterData: marketMasterData.data || [],
            defaultSelectedData: _.cloneDeep(selectedData || []),
            selectedData: selectedData || [],
            sortedAssignmentData: sortedData,
            statusData: uniqueStatusData
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  GetAssignmentsFromServer (selectedData, showInactive) {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Assignments.GetAssignmentsData + '?propertyId=' + (this.state?.selectedPropertyId?.toString() ?? '0') + '&showInactive=' + showInactive,
        key: 'assignmentData'
      }
    ])
      .then(
        ({
          assignmentData
        }) => {
          this._asyncRequest = null;
          if (assignmentData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
          this.setState({
            configuration: assignmentData.config || [],
            responseAssignmentData: assignmentData.data || [],
            assignmentData: applyFilterOnData(
              assignmentData.data || [],
              selectedData
            ),
            selectedData: selectedData || []
          });
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  componentDidMount () {
    this.GetAssignmentsDetails();
  }

  renderActionColumn = (cellInfo) => {
    return (
      <>
        { IsSectionVisible(SECTIONS.ASSIGNMENTS, 0, SECTIONS.VIEW)
          ? <Tooltip title="View">
          <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.setState({
                detailView: true,
                ViewTitle: 'Edit',
                actionType: 'Edit',
                selectedAssignment: cellInfo.assignmentId,
                selectedAssignmentPropertyId: cellInfo.propertyId
              });
            }}
          >
            <Visibility fontSize="small" size="small" />
          </IconButton>
        </Tooltip>
          : '' }
      </>
    );
  };

  onFilterChange = (selectedData) => {
    if (selectedData && selectedData.filter(x => x.key === 'showInactive') !== undefined &&
      selectedData.find(x => x.key === 'showInactive')?.selected[0]?.showInactive !==
      this.state.selectedData.find(x => x.key === 'showInactive')?.selected[0]?.showInactive) {
      this.setState({ selectedData }, () => {
        this.GetAssignmentsFromServer(selectedData, selectedData.find(x => x.key === 'showInactive')?.selected[0]?.showInactive === true);
      });
    } else {
      const { responseAssignmentData } = this.state;
      const filteredData = applyFilterOnData(
        [...responseAssignmentData],
        selectedData
      );
      this.setState({ assignmentData: filteredData, selectedData });
    }
  };

  onRowClick = (data) => {
    this.setState({
      // detailView: true,
      selectedAssignment: data.assignmentId,
      selectedAssignmentPropertyId: data.propertyId,
      ViewTitle: 'Edit',
      actionType: 'Edit'
    });
  };

  onBackClick = () => {
    this.setState({ detailView: false, selectedEmployeeId: undefined });
  };

  addNewAssignment = () => {
    this.setState({
      detailView: true,
      selectedAssignment: 0,
      selectedAssignmentPropertyId: '',
      ViewTitle: 'New',
      actionType: 'Add'
    });
  };

  static getDerivedStateFromProps (newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {
      // this.LoadData();
      return {
        reload: (((newProps || {}).location || {}).navProps || {}).reload,
        detailView: false,
        selectedEmployeeId: undefined
      };
    }
  }

  onBack = () => {
    this.setState({
      detailView: false,
      selectedEmployeeId: undefined
    });
    this.GetAssignmentsDetails();
  }

  render () {
    const {
      selectedData,
      assignmentData,
      propertyMasterData,
      serviceTypeMasterData,
      marketMasterData,
      configuration,
      detailView,
      ViewTitle,
      actionType,
      sortedAssignmentData
    } = this.state;
    return (
      <>
        {detailView
          ? (
          <>
            <AssignmentInfo
              selectedAssignment={this.state.selectedAssignment}
              selectedAssignmentPropertyId = {this.state.selectedAssignmentPropertyId}
              onBackClick={this.onBackClick}
              onBack={this.onBack}
              assignmentData={assignmentData}
              propertyMasterData={propertyMasterData}
              serviceTypeMasterData={serviceTypeMasterData}
              marketMasterData={marketMasterData}
              ViewTitle={ViewTitle}
              actionType={actionType}
            />
          </>
            )
          : (
          <>
            {this.props.renderAsChild !== true && (
              <PageHeader title="Assignments"></PageHeader>
            )}
            <PageFilter
              autoFilter={false}
              filterAlwaysVisible={this.props.renderAsChild !== true}
              onFilterChanged={this.onFilterChange}
              filterConfig={[
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: marketMasterData,
                  key: 'marketName',
                  placeholder: 'Search Market',
                  title: 'Market'
                },
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: propertyMasterData,
                  key: 'propertyName',
                  placeholder: 'Search Property',
                  title: 'Property Name',
                  isComaSeprated: true
                },
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: serviceTypeMasterData,
                  key: 'serviceType',
                  placeholder: 'Search Service Type',
                  title: 'Service Type',
                  isComaSeprated: true
                },
                {
                  multiple: true,
                  type: controlType.DropDown,
                  source: sortedAssignmentData,
                  key: 'assignmentName',
                  placeholder: 'Search Service Type',
                  title: 'Assignment Name',
                  isComaSeprated: true
                },
                {
                  multiple: true,
                  type: controlType.DropDown,
                  key: 'statusName',
                  source: this.state.statusData,
                  placeholder: 'Status',
                  title: 'Status',
                  isComaSeprated: true
                },
                {
                  type: controlType.DatePicker,
                  key: 'startDate',
                  placeholder: 'Search Property',
                  title: 'Assignment Start Date',
                  operator: Operators.GreaterThanEqualsTo
                },
                {
                  type: controlType.DatePicker,
                  key: 'endDate',
                  placeholder: 'Search Property',
                  title: 'Assignment End Date',
                  operator: Operators.LessThanEqualsTo
                },
                {
                  type: controlType.Checkbox,
                  key: 'showInactive',
                  placeholder: 'Search Assignment',
                  title: 'Show Inactive Assignment(s)'
                }
              ]}
                gridColumn={3}
                  defaultSelectedData={this.state.defaultSelectedData}
              selectedData={selectedData}
            ></PageFilter>
            <div className="row table-list-container">
              {/* <Button variant="contained" size="small" onClick={this.addNewAssignment}>
                New Assignment
              </Button> */}
            </div>
            <div className="row table-list-container">
              <GridTable
                columns={UpdateColumnWithConfiguration(
                  assignmentColumns,
                  configuration
                )}
                data={assignmentData}
                config={assignmentConfig}
                renderActionColumn={this.renderActionColumn}
                onRowClick={this.onRowClick}
                AddNewRecord={{
                  action: this.addNewAssignment,
                  title: 'Add New Assignment',
                  visible: IsSectionVisible(SECTIONS.ASSIGNMENTS, 0, SECTIONS.ADD_EDIT) && !this.props.renderAsChild
                }}
              ></GridTable>
            </div>
          </>
            )}
      </>
    );
  }
}
export default Assignments;
